// SAC_TARE_KG is the empty-sac mass deducted at the scale stage only.
// It must NOT appear in any sondage/refraction calculation — see
// QUALITY_AND_DECISION.md §1.
export const SAC_TARE_KG = 0.67

// WET_BAG_KG is the per-wet-bag deduction applied at bordereau time.
export const WET_BAG_KG = 65

export interface NetWeightInputs {
  grossWeight: number
  tareWeight: number
  bagsUnloaded: number
}

export interface NetWeightBreakdown {
  truckMinusTare: number
  bagsTareKg: number
  netWeight: number
  isValid: boolean
}

// All kg outputs are rounded to two decimals — same precision the
// backend persists at, so the live preview matches the eventual
// stored values.
export function computeNetWeight({
  grossWeight,
  tareWeight,
  bagsUnloaded,
}: NetWeightInputs): NetWeightBreakdown {
  const bagsTareKg = +(bagsUnloaded * SAC_TARE_KG).toFixed(2)
  const truckMinusTare = +Math.max(0, grossWeight - tareWeight).toFixed(2)
  const netWeight = +Math.max(0, truckMinusTare - bagsTareKg).toFixed(2)
  const isValid =
    grossWeight > 0 && tareWeight > 0 && tareWeight < grossWeight && bagsUnloaded > 0
  return { truckMinusTare, bagsTareKg, netWeight, isValid }
}

export function previewWetBagDeductionKg(bagsWet: number): number {
  return Math.max(0, bagsWet) * WET_BAG_KG
}
